import React from 'react'
import { Router as ReachRouter } from '@reach/router'
import App from '../../App'
import { OidcCallback } from '../oidcCallback/OidcCallback'
import PrivateRoute from './privateRoute/PrivateRoute'
import Transcription from '../statistic/transcription/Transcription'
import BotList from '../botList/BotList'
import Home from '../home/Home'
import Statistic from '../statistic'
import Live from '../statistic/live/Live'
import ErrorInit from '../home/errorInit/ErrorInit'
import Billing from '../billing/Billing'
import MonitoringGraph from '../statistic/monitoringGraph/MonitoringGraph'
import Analytics from '../statistic/analytics/Analytics'

type RouterProps = {}

export const Router: React.FunctionComponent<RouterProps> = (props) => {
    return (
        <ReachRouter style={{ height: '100%' }}>
            <PrivateRoute as={Home} path="/" />
            <PrivateRoute as={Statistic} path="/statistic" />
            <PrivateRoute as={Live} path="/live" />
            <PrivateRoute as={App} path="/builder" />
            <PrivateRoute as={BotList} path="/bots" />
            <PrivateRoute as={Transcription} path="/transcription" />
            <PrivateRoute as={Billing} path="/billing" />
            <PrivateRoute as={MonitoringGraph} path="/monitoringGraph" />
            <PrivateRoute as={Analytics} path="/analytics" />
            <OidcCallback path="/oidcCallback" />
            <ErrorInit path="/initError" />
        </ReachRouter>
    )
}

export default Router
